import { useEffect, useState } from "react";
import logo from "../assets/images/sphere-wms-logo.png";
import { ChevronDown } from "react-bootstrap-icons";
import { QuestionCircleFill } from "react-bootstrap-icons";

import { useLoaderStore } from "../Services/LoaderService";
import { useNavigate, useLocation } from "react-router-dom";
import { authService } from "../Services/auth/auth.service";
import useClientStore from "../store/client/useClientStore";
import useWarehouseStore from "../store/warehouse/useWarehouseStore";
import useLogoutStore from "../store/auth/useLogoutStore";
import useMenuStore from "../store/menu/useMenuStore";
import useEventSystem from "../events/useEventSystem";
import useUserStore, { userAccess } from "../store/auth/userStore";
import { getProfileName } from "../Utility/Utility";


export default function Header() {
  const { setLoading } = useLoaderStore();
  const {logout} =authService.getState();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedClient,setSelectedClient]= useState<any>();
  const [selectedWarehouse,setSelectedWarehouse]= useState<any>();
  const {clients,onchangeClient,getSelectedClient,fetchClient} = useClientStore();
  const {warehouses,onchangeWarehouse,getSelectedWarehouse,fetchWarehouse} = useWarehouseStore();
  const {fetchMenu}=useMenuStore();  
  const { event, emit } = useEventSystem();
  const [warehouseWarning, setWarehouseWarning] = useState(false);
  const [clientWarning, setClientWarning] = useState(false);
  const {fetchUser,currentUser} =useUserStore();

  // if it edit page for asn or not
  const isAsnEditMode = 
  location.pathname.includes('/inbound/asn/overview/edit/') ||
  location.pathname.includes('/outbound/orders/edit/');

  useEffect(()=>{
        fetchUser().then((user:userAccess | null)=>{
        });
  },[]);
  console.log('selectedClient',selectedClient);
  
  useEffect(() => {
    if (event?.eventName === 'show_warehouse_warning') {
      // set the warning if warehouse
      setWarehouseWarning(event.data);
    }
    if (event?.eventName === 'show_client_warning') {
      // set the warning if client
      setClientWarning(event.data);
    }
  }, [event]);
  useEffect(() => {
      fetchMenu();
      fetchClient().then(()=>{
        if (!selectedClient) {
          getSelectedClient().subscribe((client) => {
            setSelectedClient(client);
          });
        }
      })
      fetchWarehouse().then(()=>{
        if (!selectedWarehouse) {
          getSelectedWarehouse().subscribe((warehouse) => {
            setSelectedWarehouse(warehouse);
          });
        }
      })
  }, [selectedClient,selectedWarehouse]);

  const clientOnChange =(client:any) =>{
    setSelectedClient(client);
    onchangeClient(client);
  };
  
  const warehouseOnChange =(warehouse:any) =>{
    setSelectedWarehouse(warehouse);
    onchangeWarehouse(warehouse);
  };
  
  const handleLogOut = ()=>{
    setLoading(true);
    logout().then((res:any)=>{
      useLogoutStore.getState().resetAllStores();
      setLoading(false);
      navigate("/login");
    });
  } 
  return (
    <div>
      <nav className="navbar navbar-expand-sm navbar-dark bg-dark fixed-top header">
        <div className="container-fluid w-100">
          <a className="navbar-brand  mx-4" href="">
            <img src={logo} />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#mynavbar"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div
            className="collapse navbar-collapse justify-content-between"
            id="mynavbar"
          >
            <div className="d-flex">
              <div className="logo-separator me-4"></div>
              <div className="text-white align-self-center">Demo Company</div>
            </div>
            <div>
              <form className="d-flex">
                <div className="btn-group me-2">
                <button
                    className={warehouseWarning?'highlight-animate btn btn-secondary border-2 bg-transparent  dropdown-toggle rounded-pill':'btn btn-secondary border-2 bg-transparent  dropdown-toggle rounded-pill'}
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {selectedWarehouse?.name || 'All Warehouses'}
                  </button>
                  <ul className="dropdown-menu navbar-dropdown py-0 rounded client-dropdown">
                    <li
                     className={`cursor-pointer rounded ps-2 ${selectedWarehouse?.id === 0? "active" : ""}`}
                     onClick={() => warehouseOnChange({id:0,name:'All Warehouses',code:"all"})}
                    >
                      All Warehouses
                    </li>
                    {
                      warehouses?.map((warehouse:any,index:number) => (
                        <li
                          key={index}
                          onClick={() => warehouseOnChange(warehouse)}
                          className={`cursor-pointer rounded ps-2 ${selectedWarehouse?.id === warehouse.id ? "active" : ""}`}
                        >
                          {warehouse.name}
                        </li>
                      ))
                    }
                  </ul>
                </div>
                <div className={`btn-group me-2 ${isAsnEditMode ? 'cursornotallowed' : ''}`}>
                  <button
                  className={`${clientWarning?'highlight-animate btn btn-secondary border-2 bg-transparent  dropdown-toggle rounded-pill':'btn btn-secondary border-2 bg-transparent  dropdown-toggle rounded-pill'} ${isAsnEditMode ? 'disabled' : ''}`}
                    type="button"
                    data-bs-toggle={isAsnEditMode ? '' : 'dropdown'}
                    aria-expanded="false"
                    disabled={isAsnEditMode}
                  >
                    {selectedClient?.name??'All Clients'}
                  </button>
                  <ul className="dropdown-menu navbar-dropdown py-0 rounded client-dropdown">
                  <li
                   className={`cursor-pointer rounded ps-2 ${selectedClient?.id === 0? "active" : ""}`}
                     onClick={() => clientOnChange({id:0,name:'All Clients',code:"all"})}
                    >
                      All Clients
                    </li>
                    {
                      clients?.map((client:any,index:number) => (
                        <li
                          key={index}
                          onClick={() => clientOnChange(client)}
                          className={`cursor-pointer rounded ps-2 ${selectedClient?.id === client.id ? "active" : ""}`}
                        >
                          {client.name}
                        </li>
                        
                      ))
                    }
                  </ul>
                </div>
                <QuestionCircleFill className="query-cion ms-2 me-3 d-flex align-self-center cursor-pointer"/>
                {/* <div className="d-flex cursor-pointer">
                  <div className="rounded-circle bg-white text-black fw-bold profile-icon-img d-flex align-items-center justify-content-center">
                    DC
                  </div>
                  <ul className="dropdown-menu">...</ul>

                  <div className="align-self-center ms-1">
                    <ChevronDown color="white" />
                  </div>
                </div> */}
                <div className="btn-group me-2">
                  <button
                    className="btn  rounded-circle bg-white text-black fw-bold profile-icon-img d-flex align-items-center justify-content-center fs-14"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  ><span title={currentUser?.name ?? "User"}>
                  {getProfileName(currentUser?.name ?? "User")}
                  </span>
                  </button>
                  <ul className="dropdown-menu ps-2 cursor-pointer logout-dropdown " onClick={handleLogOut}>Logout</ul>
                  <button className="align-self-center ms-1 bg-transparent border-0" data-bs-toggle="dropdown">
                    <ChevronDown color="white" />
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
}
